import { useEffect, useState, useContext, useCallback } from "react";
import { Skeleton } from "primereact/skeleton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SessionCard from "./SessionCard";
import AuthContext from "../../../../auth/AuthContext";
import AlertService from "../../../../services/AlertService";
import AssessmentService from "../../../../services/AssessmentService";
import { useBreadcrumb } from "../../../../context/BreadcrumbContext";


const AssessmentSessions = () => {
  const { assessmentId } = useParams(); 
  const authContext = useContext(AuthContext);
  const location = useLocation();
  const { setDynamicLabels } = useBreadcrumb();
  const [loading, setLoading] = useState(true);
  const [sessions, setSessions] = useState([]);
  const navigate = useNavigate()

useEffect(()=>{
    const assessmentAccess = authContext.getPermissions("assessmentsmaster");
        if (assessmentAccess.filter((f) => f.access.includes(1)).length === 0) {
            navigate("/");
        }
 },[authContext, navigate]);

 useEffect(() => {
  const assessmentName = location.state?.assessmentName;

  if (assessmentName) {
    setDynamicLabels(prev => ({
      ...prev,
      [assessmentId]: assessmentName
    }));
  }
}, [assessmentId, location.state, setDynamicLabels]);

const fetchSessions = useCallback(async () => {
  try {
    setLoading(true);

    const res = await AssessmentService.GetAssessmentSessions(
      assessmentId,
      "",
      authContext
    );

    const list = Array.isArray(res?.data?.results)
      ? res.data.results
      : [];

    const mapped = list.map((s) => ({
      assessmentId: s.assessmentId,
      userId: s.userId,
      attendeeName: s.attendeeName,
      startDate: s.startDate,
    }));

    setSessions(mapped);
  } catch (err) {
    console.error("Failed to fetch quiz sessions", err);
    setSessions([]);
  } finally {
    setLoading(false);
  }
}, [assessmentId, authContext]);

  useEffect(() => {
    fetchSessions();
  }, [fetchSessions]);

  const deleteSession = async (userId) => {
    try {
      await AssessmentService.RemoveExamSession(assessmentId, userId, authContext);

      setSessions((prev) =>
        prev.filter((s) => s.userId !== userId)
      );

      AlertService.success("Session killed successfully");
    } catch (err) {
      console.error("Failed to delete session", err);
      AlertService.error("Failed to kill session");
    }
  };

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {loading &&
          Array.from({ length: 8 }).map((_, idx) => (
            <div
              key={idx}
              className="bg-white dark:bg-slate-900 rounded-md shadow flex flex-col h-full"
            >
              <div className="pt-6 flex justify-center">
                <Skeleton width="60%" height="1.25rem"   className="!bg-slate-200 dark:!bg-slate-700" />
              </div>

              <div className="mt-4 mb-6 flex justify-center">
                <Skeleton width="70%" height="1rem"   className="!bg-slate-200 dark:!bg-slate-700" />
              </div>

              <div className="mt-auto bg-slate-50 dark:bg-slate-800 py-3 flex justify-center">
                <Skeleton width="40%" height="1rem"   className="!bg-slate-200 dark:!bg-slate-700" />
              </div>
            </div>
          ))}

        {!loading &&
          sessions.map((session) => (
            <SessionCard
              key={session.id}
              data={session}
              onDelete={deleteSession}
            />
          ))}
      </div>

      {!loading && sessions.length === 0 && (
        <p className="text-center text-gray-500 mt-10">
          No sessions available
        </p>
      )}
    </div>
  );
};

export default AssessmentSessions;
